import React from "react";
import "./QuestionNavigation.css";

function QuestionNavigation({ questions }) {
  const scrollToQuestion = (questionId) => {
    const element = document.getElementById(`question-${questionId}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
      // Trigger flash highlight on the question card
      element.classList.remove("flash-highlight");
      // Force reflow to restart the animation if it was applied recently
      void element.offsetWidth;
      element.classList.add("flash-highlight");
      // Cleanup after animation completes
      setTimeout(() => {
        element.classList.remove("flash-highlight");
      }, 1400);
    }
  };

  if (questions.length === 0) {
    return null;
  }

  return (
    <div className="question-navigation">
      <div className="nav-dots">
        {questions.map((question, index) => (
          <div
            key={question.id}
            className="nav-dot-wrapper"
            onClick={() => scrollToQuestion(question.id)}
          >
            <div className="nav-dot" title={question.content} />
            <div className="nav-tooltip">
              <span className="nav-tooltip-number">{index + 1}.</span>
              <span className="nav-tooltip-text">{question.content}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QuestionNavigation;
